import React, { useEffect, useRef, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Html5Qrcode } from 'html5-qrcode';

const BarcodeModal = ({ show, onClose, onScanSuccess }) => {
  const html5QrCodeRef = useRef(null);
  const [isScanning, setIsScanning] = useState(false);
  // Trava interna para evitar disparos múltiplos durante o desligamento
  const isStoppingRef = useRef(false);

  useEffect(() => {
    if (show) {
      isStoppingRef.current = false; // Reseta a trava ao abrir
      const html5QrCode = new Html5Qrcode("reader");
      html5QrCodeRef.current = html5QrCode;

      Html5Qrcode.getCameras()
        .then(devices => {
          if (devices && devices.length > 0) {
            html5QrCode.start(
              { facingMode: "environment" },
              { fps: 10, qrbox: { width: 250, height: 150 } },
              async (decodedText) => {
                // SE JÁ ESTIVER PARANDO, IGNORA LEITURAS EXTRAS
                if (isStoppingRef.current) return;
                isStoppingRef.current = true;

                // Primeiro avisamos o pai
                onScanSuccess(decodedText);
                
                // AGUARDAMOS o scanner parar de fato antes de qualquer outra coisa
                await stopScanner();
              },
              () => {}
            ).then(() => setIsScanning(true))
             .catch(err => console.error("Erro ao iniciar scanner:", err));
          }
        })
        .catch(err => console.error("Erro ao obter câmeras:", err));
    }

    return () => {
      // Cleanup ao desmontar o componente
      if (html5QrCodeRef.current && isScanning) {
        stopScanner();
      }
    };
  }, [show]);

  const stopScanner = async () => {
    const scanner = html5QrCodeRef.current;
    if (!scanner) return;

    try {
      // Importante: verificamos se o estado do scanner da lib ainda está ativo
      if (scanner.isScanning) {
        await scanner.stop();
        await scanner.clear();
      }
      setIsScanning(false);
      const el = document.getElementById("reader");
      if (el) el.innerHTML = "";
    } catch (err) {
      console.warn("Erro ao parar scanner:", err);
    }
  };

  const handleClose = async () => {
    isStoppingRef.current = true; // Ativa a trava ao fechar manualmente
    await stopScanner();
    onClose();
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Escanear Código</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* Adicionamos uma min-height para evitar pulos na tela */}
        <div id="reader" style={{ width: "100%", minHeight: "250px" }}></div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default BarcodeModal;